var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "GetStartedLayout",
    {
      ref: "layout",
      attrs: {
        errors: _vm.errors,
        title: _vm.currentStep?.title,
        subtitle: _vm.currentStep?.subtitle,
        guest: _vm.guest,
        breadcrumbs: _vm.breadcrumbs,
        review: _vm.review,
        fluid: "",
      },
      scopedSlots: _vm._u([
        {
          key: "toggleFilter",
          fn: function () {
            return [
              _vm.shoppingCartItems
                ? _c(
                    "v-btn",
                    {
                      attrs: { icon: "", outlined: "", color: "white" },
                      on: {
                        click: function ($event) {
                          _vm.$inertia.visit(_vm.route("checkout.show"))
                        },
                      },
                    },
                    [
                      _c(
                        "v-badge",
                        {
                          attrs: {
                            content: _vm.shoppingCartItems,
                            color: "secondary",
                            overlap: "",
                            bordered: "",
                          },
                        },
                        [
                          _c("v-icon", { staticClass: "white--text" }, [
                            _vm._v("shopping_cart"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          },
          proxy: true,
        },
        {
          key: "titleAction",
          fn: function () {
            return [
              _vm.stepNumber == 0
                ? _c(
                    "v-btn-toggle",
                    {
                      staticClass: "soli-round mt-6",
                      attrs: { mandatory: "", color: "accent" },
                      model: {
                        value: _vm.membershipView,
                        callback: function ($$v) {
                          _vm.membershipView = $$v
                        },
                        expression: "membershipView",
                      },
                    },
                    [
                      _c(
                        "v-btn",
                        { attrs: { small: "", value: "privateLessons" } },
                        [_vm._v("Private Lessons")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        { attrs: { small: "", value: "groupClasses" } },
                        [_vm._v("Group Learning")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _vm._v(" "),
      _c(
        "v-window",
        {
          staticClass: "elevation-0 w-full pa-0 flex justify-center",
          staticStyle: { background: "transparent" },
          attrs: { touchless: "" },
          model: {
            value: _vm.stepNumber,
            callback: function ($$v) {
              _vm.stepNumber = $$v
            },
            expression: "stepNumber",
          },
        },
        _vm._l(_vm.stepData, function (step) {
          return _c(
            "div",
            { key: step.name },
            [
              _c(
                "v-window-item",
                {
                  staticClass: "custom-stepper",
                  staticStyle: { overflow: "visible", "min-height": "238px" },
                  attrs: { step: _vm.stepData.indexOf(step) },
                },
                [
                  _vm.currentStep.name == step.name
                    ? _c(
                        step.comp,
                        _vm._g(
                          _vm._b(
                            {
                              key: step.name,
                              tag: "component",
                              class: step.classes,
                              model: {
                                value: _vm.form[step.name],
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, step.name, $$v)
                                },
                                expression: "form[step.name]",
                              },
                            },
                            "component",
                            { ...step.props() },
                            false
                          ),
                          step.on
                        )
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("WindowMarker", {
        staticClass: "mt-1",
        attrs: { length: _vm.stepData.length },
        on: {
          input: function ($event) {
            return _vm.clearFutureSteps($event)
          },
        },
        model: {
          value: _vm.stepNumber,
          callback: function ($$v) {
            _vm.stepNumber = $$v
          },
          expression: "stepNumber",
        },
      }),
      _vm._v(" "),
      _vm.showHelp
        ? _c("SoliResponsiveDialog", {
            attrs: { fullscreen: "", bottomSheetOnly: "" },
            on: {
              reset: function ($event) {
                _vm.closeModal(() => (_vm.showHelp = false))
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [_c(_vm.showHelp.comp, { tag: "component" })]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              752632344
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }